import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d1c7893c"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("提交")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("重置")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_input_number = _resolveComponent("a-input-number")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_UploadComponent = _resolveComponent("UploadComponent")!
  const _component_a_form_item_rest = _resolveComponent("a-form-item-rest")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!

  return (_openBlock(), _createBlock(_component_a_form, {
    ref: "formRef",
    model: _ctx.formState,
    rules: _ctx.rules,
    "label-col": _ctx.labelCol,
    "wrapper-col": _ctx.wrapperCol
  }, {
    default: _withCtx(() => [
      _createVNode(_component_a_form_item, {
        ref: "name",
        label: "类型名称",
        name: "name"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_input, {
            value: _ctx.formState.name,
            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formState.name) = $event))
          }, null, 8, ["value"])
        ]),
        _: 1
      }, 512),
      _createVNode(_component_a_form_item, {
        ref: "short_name",
        label: "简称",
        name: "short_name"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_input, {
            value: _ctx.formState.short_name,
            "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formState.short_name) = $event))
          }, null, 8, ["value"])
        ]),
        _: 1
      }, 512),
      _createVNode(_component_a_form_item, {
        ref: "car_min_volume",
        label: "最小体积（m³）",
        name: "car_min_volume"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_input_number, {
            min: 1,
            value: _ctx.formState.car_min_volume,
            "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formState.car_min_volume) = $event)),
            placeholder: "请输入",
            style: {"width":"100%"}
          }, null, 8, ["value"])
        ]),
        _: 1
      }, 512),
      _createVNode(_component_a_form_item, {
        ref: "car_long",
        label: "车长（米）",
        name: "car_long"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_input_number, {
            min: 1,
            value: _ctx.formState.car_long,
            "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formState.car_long) = $event)),
            placeholder: "请输入",
            style: {"width":"100%"}
          }, null, 8, ["value"])
        ]),
        _: 1
      }, 512),
      _createVNode(_component_a_form_item, {
        ref: "car_width",
        label: "车宽（米）",
        name: "car_width"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_input_number, {
            min: 1,
            value: _ctx.formState.car_width,
            "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formState.car_width) = $event)),
            placeholder: "请输入",
            style: {"width":"100%"}
          }, null, 8, ["value"])
        ]),
        _: 1
      }, 512),
      _createVNode(_component_a_form_item, {
        ref: "car_hight",
        label: "车高（米）",
        name: "car_hight"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_input_number, {
            min: 1,
            value: _ctx.formState.car_hight,
            "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formState.car_hight) = $event)),
            placeholder: "请输入",
            style: {"width":"100%"}
          }, null, 8, ["value"])
        ]),
        _: 1
      }, 512),
      _createVNode(_component_a_form_item, {
        ref: "standard_long",
        label: "厢长（米）",
        name: "standard_long"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_input, {
            value: _ctx.formState.standard_long,
            "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formState.standard_long) = $event)),
            placeholder: "请输入"
          }, null, 8, ["value"])
        ]),
        _: 1
      }, 512),
      _createVNode(_component_a_form_item, {
        ref: "standard_hight",
        label: "厢高（米）",
        name: "standard_hight"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_input, {
            value: _ctx.formState.standard_hight,
            "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formState.standard_hight) = $event)),
            placeholder: "请输入"
          }, null, 8, ["value"])
        ]),
        _: 1
      }, 512),
      _createVNode(_component_a_form_item, {
        ref: "standard_volume",
        label: "载方（方）",
        name: "standard_volume"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_input, {
            value: _ctx.formState.standard_volume,
            "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formState.standard_volume) = $event)),
            placeholder: "请输入"
          }, null, 8, ["value"])
        ]),
        _: 1
      }, 512),
      _createVNode(_component_a_form_item, {
        ref: "standard_weight",
        label: "载重（吨）",
        name: "standard_weight"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_input, {
            value: _ctx.formState.standard_weight,
            "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.formState.standard_weight) = $event)),
            placeholder: "请输入"
          }, null, 8, ["value"])
        ]),
        _: 1
      }, 512),
      _createVNode(_component_a_form_item, {
        ref: "describe",
        label: "描述",
        name: "describe"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_textarea, {
            value: _ctx.formState.describe,
            "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.formState.describe) = $event)),
            placeholder: "多条用英文分号';'隔开"
          }, null, 8, ["value"])
        ]),
        _: 1
      }, 512),
      _createVNode(_component_a_form_item, {
        ref: "image",
        label: "图片",
        name: "image"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_input, {
            value: _ctx.formState.image,
            "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.formState.image) = $event)),
            style: {"display":"none"}
          }, null, 8, ["value"]),
          _createVNode(_component_a_form_item_rest, null, {
            default: _withCtx(() => [
              _createVNode(_component_UploadComponent, {
                "on-change": _ctx.onImageChange,
                "source-url": _ctx.formState.image
              }, null, 8, ["on-change", "source-url"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 512),
      _createVNode(_component_a_form_item, { "wrapper-col": { span: 24, offset: 6 } }, {
        default: _withCtx(() => [
          _createVNode(_component_a_button, {
            type: "primary",
            onClick: _ctx.onSubmit
          }, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_a_button, {
            style: {"margin-left":"10px"},
            onClick: _ctx.resetForm
          }, {
            default: _withCtx(() => [
              _hoisted_2
            ]),
            _: 1
          }, 8, ["onClick"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["model", "rules", "label-col", "wrapper-col"]))
}